var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5556V0H11.5556V11.5556H0ZM0 26V14.4444H11.5556V26H0ZM14.4444 11.5556V0H26V11.5556H14.4444ZM14.4444 26V14.4444H26V26H14.4444ZM2.88889 8.66667H8.66667V2.88889H2.88889V8.66667ZM17.3333 8.66667H23.1111V2.88889H17.3333V8.66667ZM17.3333 23.1111H23.1111V17.3333H17.3333V23.1111ZM2.88889 23.1111H8.66667V17.3333H2.88889V23.1111Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.cb2b35210312ce271bd968244bf0921e.svg";
export { ForwardRef as ReactComponent };